import axiosInstance from './axiosInstance';
import { Warning, CreateWarningDto, UpdateWarningDto, ApproveWarningDto, AppealWarningDto, WarningSummary, WarningFilters } from '../types/warnings.types';

const API_URL = '/Warnings';

export const warningsService = {
  getAll: async (filters?: WarningFilters): Promise<Warning[]> => {
    const params = new URLSearchParams();
    if (filters?.branchId) params.append('branchId', filters.branchId.toString());
    if (filters?.employeeId) params.append('employeeId', filters.employeeId.toString());
    if (filters?.status) params.append('status', filters.status);
    if (filters?.activeOnly !== undefined) params.append('activeOnly', filters.activeOnly.toString());
    const response = await axiosInstance.get(`${API_URL}?${params.toString()}`);
    return response.data;
  },
  getById: async (id: number): Promise<Warning> => {
    const response = await axiosInstance.get(`${API_URL}/${id}`);
    return response.data;
  },
  getSummary: async (branchId?: number): Promise<WarningSummary[]> => {
    const params = new URLSearchParams();
    if (branchId) params.append('branchId', branchId.toString());
    const response = await axiosInstance.get(`${API_URL}/summary?${params.toString()}`);
    return response.data;
  },
  create: async (data: CreateWarningDto): Promise<Warning> => {
    const response = await axiosInstance.post(`${API_URL}`, data);
    return response.data;
  },
  update: async (data: UpdateWarningDto): Promise<Warning> => {
    const response = await axiosInstance.put(`${API_URL}/${data.warningId}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  },
  acknowledge: async (id: number): Promise<Warning> => {
    const response = await axiosInstance.post(`${API_URL}/${id}/acknowledge`);
    return response.data;
  },
  approve: async (data: ApproveWarningDto): Promise<Warning> => {
    const response = await axiosInstance.post(`${API_URL}/approve`, data);
    return response.data;
  },
  appeal: async (data: AppealWarningDto): Promise<Warning> => {
    const response = await axiosInstance.post(`${API_URL}/appeal`, data);
    return response.data;
  },
  expireOld: async (): Promise<void> => {
    await axiosInstance.post(`${API_URL}/expire-old`, {});
  }
};